var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7498 0.5C14.2198 0.5 15.4198 1.65275 15.4963 3.104L15.5 3.25025V12.7498C15.5 14.2198 14.3472 15.4198 12.896 15.4963L12.7498 15.5H3.25025C2.54613 15.5 1.86882 15.23 1.35785 14.7456C0.846888 14.2611 0.541193 13.5991 0.50375 12.896L0.5 12.7498V3.25025C0.5 1.78025 1.65275 0.58025 3.104 0.50375L3.25025 0.5H12.7498ZM10.7802 5.96975C10.6396 5.82915 10.4489 5.75016 10.25 5.75016C10.0511 5.75016 9.8604 5.82915 9.71975 5.96975L7.25 8.43875L6.28025 7.46975L6.20975 7.4075C6.05901 7.29094 5.86955 7.23613 5.67986 7.2542C5.49016 7.27227 5.31446 7.36187 5.18844 7.50479C5.06241 7.64772 4.99551 7.83325 5.00133 8.02371C5.00714 8.21417 5.08524 8.39528 5.21975 8.53025L6.71975 10.0302L6.79025 10.0925C6.93455 10.2044 7.11474 10.2599 7.29701 10.2484C7.47928 10.237 7.65111 10.1594 7.78025 10.0302L10.7802 7.03025L10.8425 6.95975C10.9544 6.81545 11.0099 6.63526 10.9984 6.45299C10.987 6.27072 10.9094 6.09889 10.7802 5.96975Z",
    fill: "#45029C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkbox-check.5f41481c88c7d0ed637c93b19d599db5.svg";
export { ForwardRef as ReactComponent };